export default __webpack_public_path__ + "static/cardpunks-3c2264fbdd8e79f5d38b2846208c9570.jpg";